export const PROJECTS = [
  {
    id: "omis-2024",
    img: "/img/p-omis.webp",
    year: "2024",
    country: "HR",
    title: "Outdoor, Climbing & Wellbeing",
    it: {
      type: "Scambio giovanile Erasmus+",
      date: "12–22 ottobre 2024",
      place: "Omiš, Croazia",
      text: "Uno scambio giovanile per promuovere il benessere e la salute mentale dei giovani attraverso l'arrampicata e le attività outdoor.",
      meta: "Con giovani da Ungheria, Spagna, Italia e Romania",
    },
    en: {
      type: "Erasmus+ Youth Exchange",
      date: "12–22 October 2024",
      place: "Omiš, Croatia",
      text: "A youth exchange promoting young people's wellbeing and mental health through climbing and outdoor activities.",
      meta: "With young people from Hungary, Spain, Italy and Romania",
    },
  },
  {
    id: "ecome-2025",
    img: "/img/p-ecome.webp",
    year: "2025",
    country: "RO",
    title: "ECO-ME, ECO-WE",
    it: {
      type: "Scambio giovanile Erasmus+",
      date: "2–12 maggio 2025",
      place: "Vatra Dornei, Romania",
      text: "Un viaggio trasformativo in cui ambiente, crescita interiore e comunità si incontrano: attività all'aperto, laboratori su benessere e sostenibilità e momenti di confronto.",
      meta: "6 giovani (18–25 anni) + 1 group leader",
    },
    en: {
      type: "Erasmus+ Youth Exchange",
      date: "2–12 May 2025",
      place: "Vatra Dornei, Romania",
      text: "A transformative journey where environment, personal growth and community meet: outdoor activities, workshops on wellbeing and sustainability, and moments of sharing.",
      meta: "6 young people (18–25) + 1 group leader",
    },
  },
  {
    id: "dreamgreen-2025",
    img: "/img/p-dreamgreen.webp",
    year: "2025",
    country: "HR",
    title: "We Dream Green #RuralYouth4Climate",
    it: {
      type: "Scambio giovanile Erasmus+",
      date: "7–15 ottobre 2025",
      place: "Đurđevac, Croazia",
      text: "Uno scambio dedicato ad ambiente, natura e ruralità europea, ospitato in un ostello nel bosco.",
      meta: "7 paesi · 35 partecipanti",
    },
    en: {
      type: "Erasmus+ Youth Exchange",
      date: "7–15 October 2025",
      place: "Đurđevac, Croatia",
      text: "An exchange dedicated to the environment, nature and rural Europe, hosted in a hostel in the woods.",
      meta: "7 countries · 35 participants",
    },
  },
  {
    id: "aperitivo-2025",
    img: "/img/p-aperitivo.webp",
    year: "2025",
    country: "IT",
    title: "Aperitivo dei Desideri",
    it: {
      type: "Evento sul territorio",
      date: "2025",
      place: "Bike Fellas, Bergamo",
      text: "Una serata per chiedersi “che 2026 voglio vivere?”: mettere insieme origini e desideri per trovare una direzione, e scoprire come Erasmus+ trasforma i desideri in esperienze reali di viaggio, apprendimento e incontro.",
      meta: "Con l'Oracolo del Tamtam dei Colori · iniziativa Arte Cultura in Circolo 2025 di ARCI Bergamo",
    },
    en: {
      type: "Local event",
      date: "2025",
      place: "Bike Fellas, Bergamo",
      text: "An evening to ask “what 2026 do I want to live?”: bringing together origins and wishes to find a direction, and discovering how Erasmus+ turns wishes into real experiences of travel, learning and encounter.",
      meta: "With the Oracle of Tamtam dei Colori · part of ARCI Bergamo's Arte Cultura in Circolo 2025",
    },
  },
  {
    id: "bridges-2026",
    img: "/img/p-bridges.webp",
    year: "2026",
    country: "MD",
    title: "Building Bridges for Peace",
    it: {
      type: "Capacity Building Camp – Youth Workers",
      date: "6–11 marzo 2026",
      place: "Chișinău, Moldova",
      text: "Un training internazionale per youth worker, educatori e operatori sociali su peacebuilding, gestione dei conflitti, educazione non formale, contrasto alla disinformazione e dialogo interculturale.",
      meta: "Un percorso con attività sul territorio in Lombardia e Campania",
    },
    en: {
      type: "Capacity Building Camp – Youth Workers",
      date: "6–11 March 2026",
      place: "Chișinău, Moldova",
      text: "An international training for youth workers, educators and social workers on peacebuilding, conflict management, non-formal education, countering disinformation and intercultural dialogue.",
      meta: "A pathway with follow-up activities in Lombardy and Campania",
    },
  },
  {
    id: "mydress-2026",
    img: "/img/p-mydress.webp",
    year: "2026",
    country: "HU",
    title: "My Dress, My Choice",
    it: {
      type: "Scambio giovanile Erasmus+",
      date: "11–18 marzo 2026",
      place: "Eger, Ungheria",
      text: "Moda, corpo e identità come spazi di espressione e consapevolezza: laboratori creativi, moda sostenibile, upcycling e confronto tra giovani europei.",
      meta: "Giovani 18–30 anni",
    },
    en: {
      type: "Erasmus+ Youth Exchange",
      date: "11–18 March 2026",
      place: "Eger, Hungary",
      text: "Fashion, body and identity as spaces for expression and awareness: creative workshops, sustainable fashion, upcycling and exchange among young Europeans.",
      meta: "Young people aged 18–30",
    },
  },
  {
    id: "weave-2026",
    img: "/img/p-weave.webp",
    year: "2026",
    country: "RO",
    title: "Weave of Belonging",
    it: {
      type: "Scambio giovanile Erasmus+",
      date: "31 marzo – 9 aprile 2026",
      place: "Vatra Dornei, Romania",
      text: "Un retreat immerso nella natura per esplorare appartenenza, non-discriminazione e cittadinanza attiva, tra workshop non formali e confronti profondi.",
      meta: "Giovani da Italia, Grecia, Ucraina, Georgia, Moldova e Romania",
    },
    en: {
      type: "Erasmus+ Youth Exchange",
      date: "31 March – 9 April 2026",
      place: "Vatra Dornei, Romania",
      text: "A nature retreat exploring belonging, non-discrimination and active citizenship, through non-formal workshops and deep conversations.",
      meta: "Young people from Italy, Greece, Ukraine, Georgia, Moldova and Romania",
    },
  },
  {
    id: "intrecci-2026",
    img: "/img/p-intrecci.webp",
    year: "2026",
    country: "IT",
    title: "Intrecci di appartenenze",
    it: {
      type: "Installazione partecipativa",
      date: "2 maggio 2026",
      place: "Montesanto, Napoli",
      text: "La restituzione pubblica di Weave of Belonging: un'installazione aperta a tutti, realizzata da chi ha partecipato allo scambio, per riflettere sul senso di appartenenza nei luoghi della vita sociale.",
      meta: "Via Ventaglieri 76 · Partecipazione libera",
    },
    en: {
      type: "Participatory installation",
      date: "2 May 2026",
      place: "Montesanto, Naples",
      text: "The public follow-up of Weave of Belonging: an installation open to everyone, created by the exchange participants, to reflect on belonging in the places of social life.",
      meta: "Via Ventaglieri 76 · Free participation",
    },
  },
  {
    id: "arte-2026",
    img: "/img/p-arte.webp",
    year: "2026",
    country: "IT",
    title: "Building Bridges for Peace – Arte",
    it: {
      type: "Percorso artistico Erasmus+",
      date: "8–9 agosto 2026",
      place: "Montefusco (AV), Campania",
      text: "Un percorso internazionale per giovani creativi dedicato al peacebuilding e all'espressione artistica: un Summer Weekend e un Winter Weekend in Campania, poi la mobilità finale in Bulgaria a maggio 2027.",
      meta: "Giovani creativi 18–35 anni",
    },
    en: {
      type: "Erasmus+ artistic pathway",
      date: "8–9 August 2026",
      place: "Montefusco (AV), Campania",
      text: "An international pathway for creative young people focused on peacebuilding and artistic expression: a Summer Weekend and a Winter Weekend in Campania, then a final mobility in Bulgaria in May 2027.",
      meta: "Creative young people aged 18–35",
    },
  },
  {
    id: "cbc-2026",
    img: "/img/p-cbc.webp",
    year: "2026",
    country: "NL",
    title: "Communication by Connection",
    it: {
      type: "Training Course Erasmus+",
      date: "12–21 agosto 2026",
      place: "Ommen, Paesi Bassi",
      text: "Un training per chi crede che la comunicazione sia uno strumento di inclusione, partecipazione e cambiamento sociale: educazione non formale e apprendimento esperienziale per creare connessioni autentiche in una società polarizzata.",
      meta: "6 partecipanti residenti in Italia (20–40 anni): youth worker, educatori, volontari, attivisti",
    },
    en: {
      type: "Erasmus+ Training Course",
      date: "12–21 August 2026",
      place: "Ommen, the Netherlands",
      text: "A training for those who believe communication is a tool for inclusion, participation and social change: non-formal education and experiential learning to build authentic connections in a polarised society.",
      meta: "6 participants living in Italy (20–40): youth workers, educators, volunteers, activists",
    },
  },
];
